import { render, staticRenderFns } from "./StatusCell.vue?vue&type=template&id=5fa5024d&scoped=true"
import script from "./StatusCell.vue?vue&type=script&lang=js"
export * from "./StatusCell.vue?vue&type=script&lang=js"
import style0 from "./StatusCell.vue?vue&type=style&index=0&id=5fa5024d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa5024d",
  null
  
)

export default component.exports